import AsyncStorage from '@react-native-async-storage/async-storage';
import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';
import {StorageKeys} from '../constants/StorageKeys';

interface BiometricState {
  biometricEnabled: boolean;
  setBiometricEnabled: (biometricEnabled: boolean) => void;
}

export const useBiometricStore = create(
  persist<BiometricState>(
    set => ({
      biometricEnabled: false,
      setBiometricEnabled: (biometricEnabled: boolean) =>
        set(() => ({biometricEnabled})),
    }),
    {
      name: StorageKeys.BIOMETRIC_ENABLED,
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
